<svelte:head>

</svelte:head>

<script>

import { onMount, onDestroy } from 'svelte';

import { loggedIn                                                   } from '../_services/accountsession.js';

// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------


	let seconds = 0;
   let query_environment = 'dev';
   let query_id = '3qv2uWfLbTNpjDC0';
   let query_pid = "";

  let display_loadtimer = false;
   
	const interval = 0;

   let display_pivot = false;

	var is_dataLoaded = false;
	onMount(async () => {
		if ($loggedIn) {
		}
			is_dataLoaded = true;
		dependenciesLoaded();
	});

  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
//  		       && is_jqueryLoaded 
//  		       && is_jqueryuiLoaded 
  		       && is_dataLoaded 
  		   )
  	  {
			is_dependenciesLoaded = true;
	//		buildApplet();
  		}
  }

  var is_jqueryLoaded = false;
/*  function jqueryLoaded() {
		// The external javascript library is ready.
		is_jqueryLoaded = true;
		dependenciesLoaded();
  }
*/

  var is_jqueryuiLoaded = false;
/*  function jqueryuiLoaded() {
		// The external javascript library is ready.
		is_jqueryuiLoaded = true;
		dependenciesLoaded();
  }
*/

// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------

$: display_applet = is_dependenciesLoaded;

</script>


<style>

	.applet {
		width: inherit;
		height: inherit;
	}
	
	.jsfiddle {
		width: inherit;
		height: 650px;
	}

</style>


<div class="applet">

	{#if $loggedIn}
	<div>
		<!-- <p>Logged in...</p> -->
	</div>
	
	{:else}
	<div>
		<!-- <p>Please log in...</p> -->
	</div>
	{/if}
	
		{#if is_dependenciesLoaded}
	
			{#if  display_applet}
			<iframe class="jsfiddle" title="ObservableHQ PhoneSubscription Search"
	         src="//www.artificiality.be/apps/ObservableHQ_PhoneSubNNSearch/" 
	         allowfullscreen="allowfullscreen" 
	         frameborder="0"></iframe>
		
			{:else if display_loadtimer}
			<div>
				<p>It's been running for {seconds} seconds</p>
				<p>query_pid: {query_pid} </p>
			</div>
		
			{:else}
			<div>
				<p> Scripts loaded </p>		
				<p> Loading data and what not... </p>			
			</div>
	
			{/if}
	
		{:else}
		<div>
			<p> Loading scripts and what not... </p>			
		</div>
	
		{/if}


</div>